import React from 'react';
import {withStyles} from '@material-ui/core/styles';


const styleSheet = () => ({
    container: {
        display: "flex",
        flexDirection: "column",
    },

    image: {
        border: '1px solid black',
        width: "100%",
        maxWidth: "130px",
        borderRadius: "10px",
        margin: "10px 0"
    },
});

class ImageField extends React.PureComponent {

    componentDidMount() {
        const {file, getImageLink} = this.props
        if (file && getImageLink) {
            getImageLink(file.id)
        }
    }

    render() {
        const {classes, link} = this.props

        if (!link) return null

        return (
            <div className={classes.container}>
                <img className={classes.image} src={link} alt={"image"}/>
            </div>
        )
    }
}

export default withStyles(styleSheet)(ImageField);